<div class="dialog"
  fxLayout="column"
  fxLayoutGap="10px"
  (click)="close()">

  <div>Wo willst du es teilen?</div>

  <share-button button="facebook"
    [url]="entity.getOpgraphData().url"
    [showText]="true"></share-button>

  <share-button button="whatsapp"
    [url]="entity.getOpgraphData().url"
    [showText]="true"></share-button>

  <share-button button="messenger"
    [url]="entity.getOpgraphData().url"
    [showText]="true"></share-button>

  <share-button button="email"
    [url]="entity.getOpgraphData().url"
    [showText]="true"></share-button>

</div>